//监听键盘按键事件
export function handleHotKey(event, ncModal) {
    // 快捷键事件 增加top的判断避免所有弹窗逻辑都被触发
    if (ncModal && ncModal.current.isTopModal()) {
        // 防止弹窗内有参照快捷键触发
        if (event.target && event.target.className == "refer-pop-window  drag-area") {
            return false;
        }
        if (event.target.className.indexOf("modal") > -1 || event.target.className.indexOf("nc-input") > -1) {
            let isModalShow = this.props.show || this.props.visible;
            let e = event || window.event || arguments.callee.caller.arguments[0];
            if (e && e.keyCode && isModalShow) {
                if (e.keyCode == 13) {
                    this.props.onOk && this.props.onOk();
                }
            }
        }
    }

}
